/* ═══════════════════════════════════════════
   HOUSE OF PRAGATI — Theme JavaScript
   ═══════════════════════════════════════════ */

(function() {
  'use strict';

  /* ═══════════ MOBILE NAV ═══════════ */
  const navToggle = document.querySelector('.nav-toggle');
  const mainNav = document.querySelector('.main-nav');

  if (navToggle && mainNav) {
    navToggle.addEventListener('click', function() {
      mainNav.classList.toggle('active');
      const isOpen = mainNav.classList.contains('active');
      navToggle.setAttribute('aria-expanded', isOpen);
      // Toggle hamburger/close icon
      const icon = navToggle.querySelector('svg use');
      if (icon) {
        icon.setAttribute('href', isOpen ? '#icon-close' : '#icon-menu');
      }
    });

    // Close nav when clicking outside
    document.addEventListener('click', function(e) {
      if (!navToggle.contains(e.target) && !mainNav.contains(e.target)) {
        mainNav.classList.remove('active');
        navToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ═══════════ SCROLL ANIMATIONS ═══════════ */


  // Apply visible state
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.is-visible').forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    });
  });

  // Mutation observer for dynamically added elements
  const visibilityObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.classList && node.classList.contains('is-visible')) {
          node.style.opacity = '1';
          node.style.transform = 'translateY(0)';
        }
      });
    });
  });
  visibilityObserver.observe(document.body, { childList: true, subtree: true });

  /* ═══════════ HEADER SCROLL EFFECT ═══════════ */
  const header = document.querySelector('.site-header');
  let lastScroll = 0;

  if (header) {
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 100) {
        header.style.boxShadow = '0 2px 20px rgba(44, 36, 33, 0.06)';
      } else {
        header.style.boxShadow = 'none';
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ═══════════ PRODUCT IMAGE GALLERY ═══════════ */
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImage = document.querySelector('.product-gallery__main img');

  if (thumbs.length > 0 && mainImage) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const newSrc = this.querySelector('img').src;
        mainImage.src = newSrc;
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  /* ═══════════ QUANTITY SELECTOR ═══════════ */
  document.querySelectorAll('.quantity-selector').forEach(function(selector) {
    const minus = selector.querySelector('.qty-minus');
    const plus = selector.querySelector('.qty-plus');
    const input = selector.querySelector('.qty-input');

    if (minus && plus && input) {
      minus.addEventListener('click', function() {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
      plus.addEventListener('click', function() {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  /* ═══════════ AJAX CART ═══════════ */
  window.HouseOfPragati = window.HouseOfPragati || {};

  window.HouseOfPragati.addToCart = function(variantId, quantity) {
    quantity = quantity || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      // Update cart count in header
      HouseOfPragati.updateCartCount();
      return data;
    });
  };

  window.HouseOfPragati.updateCartCount = function() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var countEls = document.querySelectorAll('.cart-count');
        countEls.forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      });
  };

  // Init cart count on page load
  if (document.querySelector('.cart-count')) {
    window.HouseOfPragati.updateCartCount();
  }

  /* ═══════════ ADD TO CART FORM ═══════════ */
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(form);
      var variantId = formData.get('id');
      var quantity = formData.get('quantity') || 1;
      
      var btn = form.querySelector('.add-to-cart');
      var originalText = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;

      HouseOfPragati.addToCart(variantId, parseInt(quantity))
        .then(function() {
          btn.textContent = 'ADDED ✓';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function() {
          btn.textContent = 'ERROR';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        });
    });
  });

})();
